<template>
  <div class="hello">

    <div class="aboutUsDiv">
        <div class="aboutUsContent">
            <div class="contentTitle">最新资讯</div>

            <div class="articleDiv" v-if="inforList.length>0">

                <div class="articleContentDiv" v-for="infor in inforList" :key="infor.id">
                    <div class="articleName" :title="infor.title"><a target="_blank" :href="infor.link">{{ infor.title }}</a></div>
                    <div class="articleDetailDiv">
                        <div class="articleLeft"><img :src="infor.picUrl" alt=""/></div>
                        <div class="articleRight">
                            <div class="articleRemark" :title="infor.remark">{{infor.remark}}</div>
                            <div class="articleLink"><a target="_blank" :href="infor.link">阅读全文>></a></div>
                            <div class="articleTime">发表于 {{ infor.publishTime }}</div>
                        </div>
                    </div>
                </div>



            </div>

            <el-pagination style="margin-bottom: 40px;" @current-change="getInformation" background layout="prev, pager, next" :current-page='pageNum' :page-count='pagecount' :page-size="pageSize" > </el-pagination>

        </div>
    </div>


    

    

  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  data(){
    return {
      path: this.newCommon["publicDef"]["newPath"],
      pageSize: 10,
      pageNum: 1,
      pagecount: 1,
      inforList: [],
    }

  },
  props: {

  },
  mounted() {
    this.getInformation(this.pageNum);
  },
  methods: {
    getInformation(pageNum) {
      this.openFullScreen();
      this.fullscreenLoading = true;
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 2000);
      this.axios({
        url:  this.path + "api/teachingmatin/page",
        method:"post",
        params: {
          pageNum: pageNum,
          pageSize: 10,
          title: ''
        }
      }).then( (response)=> {
          let sessDta = response.data;
          console.log(sessDta)
          this.loading.close();
          if(sessDta.code == 200){
            this.inforList = sessDta.data.list;
            this.pagecount = sessDta.data.pages;
           
          }else {
            this.loading.close();
            this.openError();
          }
          
          
      }).catch( (error)=> {
          this.loading.close();
          this.openError();
      });

      
      
      
    },
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // setTimeout(() => {
      //   this.loading.close();
      // }, 2000);
    },
    openError() {
      this.$alert('网络异常', '', {
        confirmButtonText: '确定',
        center: true,
      });
    }

  }
}
</script>

<style scoped>
.aboutUsDiv {
    width: 1080px;
    margin: 0 auto;
}

.aboutUsContent {
    width: 100%;
    border-top: 1px solid #333;
    margin-top: 50px;
    position: relative;
}
.contentTitle {
    width: 200px;
    text-align: center;
    line-height: 40px;
    position: absolute;
    background-color: #fff;
    top: -20px;
    left: 420px;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 2px;
}
.articleDiv {
    width: 1080px;
    margin: 40px auto;
    text-align: left;
}
.articleContentDiv {
    width: 1080px;
    margin: 40px auto;
    border: 1px solid #cecece;
    padding: 30px 40px;
    box-sizing: border-box;
}
.articleName a {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #428bca;
}
.articleDetailDiv {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    margin-top: 40px;
    justify-content: space-between;
}
.articleLeft {
    width: 400px;
    flex-shrink: 0;
    margin-right: 50px;
}
.articleLeft img {
    width: 100%;
    height: 200px;
}
.articleRight {
    width: 100%;
    flex-shrink: 1;
}
.articleRemark {
    font-size: 15px;
    line-height: 30px;
    text-indent: 2em;
    height: 120px;
    overflow: hidden;
}
.articleLink {
    text-align: right;
    margin: 10px 0;
}
.articleLink a {
    font-size: 14px;
    color: #ff7a7a;
    letter-spacing: 1px;
}
.articleTime {
    text-align: right;
    font-size: 14px;
    margin: 15px 0;
    color: #cecece;
}


</style>
